import React from 'react';

import { LyingPersonIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../types';

type LyingEvent = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    overview?: AnalyticDetailsEvent['event']['overview'] & {
      detection?: Record<string, unknown>;
    };
    lying_score?: number;
  };
};

export function LyingDetails({ event }: { event: LyingEvent }): React.JSX.Element {
  const { t } = useTranslation();
  const score = calculateProbabilityPercent(event.event.lying_score);
  const detection = event.event.overview?.detection;

  return (
    <BaseVideoAnalyticsDetails
      detections={detection ? [detection] : []}
      detectionType="bbox"
      event={event}
      tags={(
        <Tag
          data-testid="workspace.analyticEventDetails.extraTagType"
          icon={<LyingPersonIcon />}
          kind="neutral"
          size="large"
          value={`${t('videoAnalytics:lyingAnalyticDetails.workspace.tag.label')} ${score}%`}
        />
      )}
      title={t('videoAnalytics:lyingAnalyticDetails.workspace.title')}
    />
  );
}
